import { createRouter, createWebHistory } from 'vue-router'

import LoginView from '@/views/LoginView.vue';
import MainDashiew from '@/views/MainDashiew.vue';
import SeguradosView from '@/views/insideviews/segurados/SeguradosView.vue';
import EmpresasView from '@/views/insideviews/empresas/EmpresasView.vue';
import PlanosView from '@/views/insideviews/planos/PlanosView.vue';
import ApolicesView from '@/views/insideviews/apolices/ApolicesView.vue';
import AgendamentosView from '@/views/insideviews/agendamentos/AgendamentosView.vue';
import ListaDeAgendamentosView from '@/views/insideviews/listas_de_agendamentos/ListaDeAgendamentosView.vue';
import VisitasView from '@/views/insideviews/visitas/VisitasView.vue';
import UploadsView from '@/views/insideviews/uploads/UploadsView.vue';
import UsuarioDashView from '@/views/insideviews/dashboard_usuario/UsuarioDashView.vue';
import GerenciamentoRotasView from '@/views/insideviews/gerenciamento_rotas/GerenciamentoRotasView.vue';
import ListaDeAgendamentosRotaView from '@/views/insideviews/listas_de_agendamentos/ListaDeAgendamentosRotaView.vue';
import PropostasView from '@/views/insideviews/propostas/PropostasView.vue';
import AtendimentosWhatsAppCommonView from '@/views/insideviews/atendimentos_whats_app/AtendimentosWhatsAppCommonView.vue';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/maindash',
    name: 'MainDash',
    component: MainDashiew,
    redirect: '/userdash',
    children:[
      {
        path: '/userdash',
        name: 'userdash',
        component: UsuarioDashView,
      },
      {
        path: '/segurados',
        name: 'segurados',
        component: SeguradosView,
      },
      {
        path: '/empresas',
        name: 'empresas',
        component: EmpresasView,
      },
      {
        path: '/whats-app',
        name: 'whats-app',
        component: AtendimentosWhatsAppCommonView,
      },
      {
        path: '/planos',
        name: 'planos',
        component: PlanosView,
      },
      {
        path: '/apolices',
        name: 'apolices',
        component: ApolicesView,
      },
      {
        path: '/agendamentos',
        name: 'agendamentos',
        component: AgendamentosView,
      }
      ,
      {
        path: '/listas-agendamentos',
        name: 'listaAgendamentos',
        component: ListaDeAgendamentosView,
      }
      ,
      {
        path: '/listas-rotas',
        name: 'listaRotas',
        component: ListaDeAgendamentosRotaView,
      }
      ,
      {
        path: '/visitas',
        name: 'visitas',
        component: VisitasView,
      }
      ,
      {
        path: '/propostas',
        name: 'propostas',
        component: PropostasView,
      }
      ,
      {
        path: '/uploads',
        name: 'uploads',
        component: UploadsView,
      }
      ,
      {
        path: '/gerenciamento-rotas',
        name: 'geremciamentoRotas',
        component: GerenciamentoRotasView,
      }
    ]
  },
]



const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const myUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");

  if (to.name !== 'Login' && (!myUser || Object.keys(myUser).length === 0)) {
      // Usuário não autenticado, redireciona para login
      next({ name: 'Login' });
  } else {
      // Usuário autenticado, permite acesso
      next();
  }
});

export default router
